<div class="row">
  <div class="col-md-12 text-center">
    <button *ngIf="!isEdit" type="button" class="btn btn-default btn-sm" (click)="add()">Add</button>
    <button *ngIf="isEdit" type="button" class="btn btn-default btn-sm" (click)="edit()">EDIT</button>
    &nbsp;/&nbsp;
    <button type="button" class="btn btn-primary btn-sm" (click)="clear()">Clear</button>
  </div>
</div>
